<template lang="pug">
  div
    .heading DNS Lookup
    .subtitle This page allows you to query for DNS records for a specific hostname and type.
    DNSLookup
</template>
<script>
import DNSLookup from "@/components/DNSLookup";

export default {
  components: {
    DNSLookup: DNSLookup,
  },
};
</script>
